export const getVariantFromURL = () => {
  let params = new URLSearchParams(window.location.search);
  let variantId = params.get('variant');
  return variantId ? parseInt(variantId) : null;
};

export const buildGalleryImages = ({ images, variant }) => {
  let firstImageIndex =
    images?.findIndex((image) => image.variant_ids.includes(variant)) > -1
      ? images.findIndex((image) => image.variant_ids.includes(variant))
      : 0;
  let nextVariantIndex = images.slice(firstImageIndex + 1).findIndex((image) => image.variant_ids.length > 0);
  let variantImages =
    nextVariantIndex > -1 ? images.slice(firstImageIndex, firstImageIndex + nextVariantIndex + 1) : images.slice(firstImageIndex);
  return variantImages;
};
